import { Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';

@Pipe({
  name: 'getIndustryNameById',
  standalone: false
})
export class GetIndustryNameByIdPipe implements PipeTransform {
  constructor(
    private appData: AppdataService
  ) { }
  async transform(id: string): Promise<string> {
    let r = await this.appData.industryTypes.find(industry => industry.id === id);
    if (r)
      return r.name_en;
    else return id;
  }

}
